import React from 'react';

export default React.memo(
  () => <div className="divider" />,
  () => true
);
